module.exports = __webpack_public_path__ + "de77a722/img/pdf-icon.79f04a36.svg";